const domainGuideLang = {
  Status: {
    ACTIVE: {
      Title: 'ACTIVE',
      ColumnTitle: 'Active',
    },
    INACTIVE: {
      Title: 'INACTIVE',
      ColumnTitle: 'Inactive',
    },
    DELETED: {
      Title: 'DELETED',
      ColumnTitle: 'Deleted',
    },
  },
  Detail: {
    EmptyValue: '-',
    NotFound: 'Domain guide not found',
    Fields: {
      DomainGuideId: 'Domain guide ID',
      Description: 'Description',
      Status: 'Status',
      CreatedBy: 'Created by',
      CreatedAt: 'Created',
      UpdatedAt: 'Updated',
    },
    RawDomainGuide: {
      Title: 'Raw Domain Guide',
    },
  },
};

export default domainGuideLang;
